/* 留痕事件 eventid 常量 */
export default {
    acct_download_file: "acct/download/file", // 下载留痕
    // 无协议同意留痕
    quick_redemption_agreement: "quick/redemption/agreement", // 同意快速赎回协议留痕
    fund_sdx_agreement_agree: "fund/sdx/agreement/agree", // 同意销售适当性风险提示及声明
    fund_risk_filter_agreement_agree: "fund/risk/filter/agreement/agree", // 同意申请展示全部产品/申请恢复过滤展示（产品展示适当性说明）
    // cms协议留痕
    cms_protocol_agreement_agree: "cms/protocol/agreement/agree", // 通用协议留痕（要加/{类型}）
    cms_fund_agreement_agree: "cms/fund/agreement/agree", // 通用产品文件协议留痕（要加/{类型}）
    before_purchasing_verification: "before/purchasing/verification", // 购买前校验
    fund_risk_agreement_agree: "fund/risk/agreement/agree", // 风险揭示书提示内容确认

};
